module.exports = new __parcel__URL__("C4S1.fc6ae179.png").toString();